import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import Slid from 'react-slick'; 
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useLocation } from 'react-router-dom';
import { BASE_URL } from './Config/Config';
import Loader from './Loader/Loader';

function Slider() {
  const [homeSlides, setHomeSlides] = useState([]);
  const [loading , setloading] = useState(true);
  useEffect(() => {
    const getdata = async () => {
      setloading(true);
      try {
        const response = await fetch(`${BASE_URL}/homeslidemaster/`, {
          method: "GET",
          headers: {
            'content-type': "application/json"
          },
          credentials: "include",
        });
        
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        } else {
          const res_data = await response.json();
          setHomeSlides(res_data.data.slice(0,3));
          console.log(res_data);  
          console.log(homeSlides)
        }
      } catch (error) {
        console.error("Failed to fetch data", error);
      }
      finally{
         setloading(false);
      }
    };

    getdata();
 
  },[]);

  const location = useLocation();
  useEffect(() => {
    // Set background image from data-bg-src
    const bgSrcElements = document.querySelectorAll('[data-bg-src]');
    bgSrcElements.forEach((element) => {
      const src = element.getAttribute('data-bg-src');
      if (src) {
        element.style.backgroundImage = `url(${src})`;
        element.classList.add('background-image');
        element.removeAttribute('data-bg-src');
      }
    });

    // Set background color from data-bg-color
    const bgColorElements = document.querySelectorAll('[data-bg-color]');
    bgColorElements.forEach((element) => {
      const color = element.getAttribute('data-bg-color');
      if (color) {
        element.style.backgroundColor = color;
        element.removeAttribute('data-bg-color');
      }
    });

    // Set mask image from data-mask-src
    const maskSrcElements = document.querySelectorAll('[data-mask-src]');
    maskSrcElements.forEach((element) => {
      const mask = element.getAttribute('data-mask-src');
      if (mask) {
        element.style.maskImage = `url(${mask})`;
        element.style.WebkitMaskImage = `url(${mask})`;
        element.classList.add('bg-mask');
        element.removeAttribute('data-mask-src');
      }
    });
  },[location.pathname]); 

const settings = {
  dots: true,
  // appendDots: dots => (
  //   <div style={{ background:"#0575BC"  }}>
  //     <ul style={{ margin: "0px",padding:"10px" }}> {dots} </ul>
  //   </div>
  // ),
  customPaging: i => (
    <button
      style={{
        width: "12px",
        height: "12px",
        backgroundColor: "gray",
        borderRadius: "50%",
        border: "none",
        // opacity: "0.5"
      }}
    ></button>),
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  speed: 500,
  fade: true
};

console.log("homeSlides",homeSlides)
  return (
   <>
  {
    loading ? (<Loader/>):(

     <div  className="th-hero-wrapper hero-1" id="hero" >
       <Slid {...settings} className="hero-slider-1 th-carousel" data-fade="true" data-dots="true">
        {homeSlides.map((data, index) => (
          <div key={index} className="th-hero-slide">
            <div className="th-hero-bg" data-overlay="title" data-opacity={6} style={{ backgroundImage: `url(${BASE_URL}${data.slider_img_bg})`}} />
            
            <div className="container">
              <div className="row align-items-center justify-content-center">
                <div className="col-md-6">
                  <div className="hero-style1">
                    <span className="hero-subtitle" data-ani="slideinleft" data-ani-delay="0.1s">
                      <span>{data.offer_off_button}</span> {data.first_line}
                    </span>
                    <h1 className="hero-title text-white" data-ani="slideinleft" data-ani-delay="0.4s">
                      {data.header_text} <span className="text-theme">and Success</span>
                    </h1>
                    <p className="hero-text" data-ani="slideinleft" data-ani-delay="0.6s">{data.description}</p>
                    
                    <div className="btn-group" data-ani="slideinleft" data-ani-delay="0.8s">
                      <NavLink to={data.get_more_link} className="th-btn style3">
                        Get Started<i className="fas fa-arrow-right ms-2" />
                      </NavLink>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 text-lg-end text-center">
                  <div className="hero-img1">
                    <img src={`${BASE_URL}${data.slider_img}`} alt="Empowering Yourself"  />
                  </div>
                </div>
              </div>
            </div>
            <div className="hero-shape shape1">
              <img src="assets/img/hero/shape_1_1.png" alt="shape" />
            </div>
            <div className="hero-shape shape2">
              <img src="assets/img/hero/shape_1_2.png" alt="shape"  />
            </div>
            <div className="hero-shape shape3">
              <img src="assets/img/hero/shape_2_4.png" alt="shape" />
            </div>
            <div className="hero-shape shape4 shape-mockup jump-reverse" data-right="3%" data-bottom="7%">
              <img src="assets/img/hero/shape_1_3.png" alt="shape" />
            </div>
            <div className="hero-shape shape5 shape-mockup jump-reverse" data-left="0" data-bottom="0">
              <img src="assets/img/hero/shape_1_4.png" alt="shape" />
            </div>

            
          </div>
        ))}
      </Slid>

      </div>
       )}

      </>
  )
      
    }

    




  
  
  

export default Slider;
